/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespPriceNegotiationToast_item$ref = any;
export type PdpRespPriceNegotiationToastLoader_item$ref = any;
export type PdpRespPriceNegotiationToastLoader_item = {
    readonly " $fragmentRefs": PdpRespPriceNegotiationToast_item$ref;
    readonly " $refType": PdpRespPriceNegotiationToastLoader_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespPriceNegotiationToastLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespPriceNegotiationToast_item",
      "args": null
    }
  ]
};
(node as any).hash = 'e9343e42edaea92c66366e4b50669692';
export default node;
